import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { useCurrency } from "@/context/CurrencyContext";
import { fmtMoney } from "@/lib/api";
import { CurrencySelect } from "@/components/CurrencySelect";

export const PricingCards = ({ showSelect = true }) => {
  const { currency, config } = useCurrency();
  if (!config) return <div className="h-96 rounded-2xl bg-muted animate-pulse" />;
  const plans = Object.entries(config.plans);
  return (
    <div>
      {showSelect && (
        <div className="mb-8 flex flex-wrap items-center gap-3">
          <span className="text-sm text-muted-foreground">Show prices in</span>
          <CurrencySelect testId="pricing-currency-select" />
          <span className="text-xs text-muted-foreground">{currency === "INR" ? "Inclusive of 18% GST" : "Taxes as applicable in your country"}</span>
        </div>
      )}
      <div className="grid gap-6 md:grid-cols-3">
        {plans.map(([id, p]) => (
          <div key={id} data-testid={`plan-card-${id}`} className={`relative card-box p-7 md:p-8 flex flex-col lift ${p.popular ? "glow-border shadow-2xl shadow-[#7c3aed]/20" : ""}`}>
            {p.popular && <span className="absolute -top-3 left-7 rounded-full bg-brand px-3 py-1 font-mono text-[10px] uppercase tracking-widest text-white">Most popular</span>}
            <h3 className="text-2xl font-bold">{p.name}</h3>
            <p className="mt-2 text-sm text-muted-foreground min-h-[40px]">{p.tagline}</p>
            <div className="mt-6 flex items-end gap-1">
              <span data-testid={`plan-price-${id}`} className="font-display text-4xl font-extrabold tracking-tight">{fmtMoney(p.prices[currency], currency, config.symbols)}</span>
              <span className="pb-1 text-sm text-muted-foreground">/month{currency === "INR" ? " incl. GST" : ""}</span>
            </div>
            <ul className="mt-7 space-y-3 flex-1">
              {p.features.map((f) => (
                <li key={f} className="flex gap-3 text-sm"><Check className="h-4 w-4 mt-0.5 shrink-0 text-[#10b981]" />{f}</li>
              ))}
            </ul>
            <Link to={`/checkout?type=plan&item=${id}`} data-testid={`plan-choose-${id}`} className={`mt-8 ${p.popular ? "btn-brand" : "btn-ghost"} w-full`}>Choose {p.name}</Link>
          </div>
        ))}
      </div>
      <p className="mt-6 text-xs text-muted-foreground max-w-3xl">
        Prices are indicative and billed monthly. Media spend on advertising platforms and third-party subscriptions are paid directly to those providers. Exchange-converted prices are rounded. Sliance makes no guarantee of specific marketing outcomes.
      </p>
    </div>
  );
};
